import isEqual from 'fast-deep-equal';
import { getErroredState } from "./getErroredState";
import { setInputState } from "./setInputState";
export var getFormInputsState = function getFormInputsState(form, inputName, inputState) {
  var previousInputState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  switch (true) {
    case isEqual(previousInputState, inputState):
      return;

    case !previousInputState.isBlurred && inputState.isBlurred:
    case inputState.isBlurred && previousInputState.value !== inputState.value:
      var errorState = getErroredState(form.props.validation[inputName], inputState);
      setInputState(form, inputName, errorState);
      return;

    case previousInputState.value !== inputState.value:
      setInputState(form, inputName, {
        error: undefined,
        isValid: undefined
      });
      return;

    default:
      break;
  }
};